import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalMenuImageItemsDocument = gql`
  query SalesPortalMenuImageItems($imageUrls: [String!]!) {
    getItemsFromMenuImages(image_urls: $imageUrls) {
      items {
        ingredients
        item_name
      }
    }
  }
`;
export function useSalesPortalMenuImageItemsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalMenuImageItemsQuery,
    Types.SalesPortalMenuImageItemsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalMenuImageItemsQuery,
    Types.SalesPortalMenuImageItemsQueryVariables
  >(SalesPortalMenuImageItemsDocument, options);
}
export function useSalesPortalMenuImageItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalMenuImageItemsQuery,
    Types.SalesPortalMenuImageItemsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalMenuImageItemsQuery,
    Types.SalesPortalMenuImageItemsQueryVariables
  >(SalesPortalMenuImageItemsDocument, options);
}
export type SalesPortalMenuImageItemsQueryHookResult = ReturnType<
  typeof useSalesPortalMenuImageItemsQuery
>;
export type SalesPortalMenuImageItemsLazyQueryHookResult = ReturnType<
  typeof useSalesPortalMenuImageItemsLazyQuery
>;
export type SalesPortalMenuImageItemsQueryResult = Apollo.QueryResult<
  Types.SalesPortalMenuImageItemsQuery,
  Types.SalesPortalMenuImageItemsQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalMenuImageItemsQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalMenuImageItemsQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalMenuImageItemsQuery,
    Types.SalesPortalMenuImageItemsQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalMenuImageItemsQuery,
    Types.SalesPortalMenuImageItemsQueryVariables
  >(SalesPortalMenuImageItemsDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalMenuImageItemsLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalMenuImageItemsLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalMenuImageItemsQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalMenuImageItemsQuery,
    Types.SalesPortalMenuImageItemsQueryVariables
  >(SalesPortalMenuImageItemsDocument, lazyOptions);
}
